import script from "./AppAside.vue?vue&type=script&setup=true&lang=js"
export * from "./AppAside.vue?vue&type=script&setup=true&lang=js"

import "./AppAside.vue?vue&type=style&index=0&id=9a2c2fca&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/PRD_sharetreats_v1_hr_admin_dashboard_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a2c2fca"]])

export default __exports__